import omit from 'ramda/es/omit';
import pipe from 'ramda/es/pipe';
import prop from 'ramda/es/prop';
import React from 'react';
import { Helmet } from 'react-helmet';

// The following children array transformation is required as
// react-helmet will only allow valid html tags for its children
// and the `children` prop contain html tags wrapped in MDX nodes
const Head = ({ children }: { children: React.ReactNodeArray }): JSX.Element => (
  <Helmet>
    {children.map(pipe(prop('props'), omit(['originalType', 'mdxType']))).map((props, index) => (
      <meta key={index} {...props} />
    ))}
  </Helmet>
);

export default Head;
